<!-- 溯源码回收站 -->
<template>
    <div class="container">
        <div class="header-container">
            <Alert type="warning" show-icon>
                回收站数据一旦删除无法恢复。请谨慎操作
            </Alert>
            <div class="header">
                <Input
                    class="mr24 mb24 w200"
                    type="text"
                    v-model="storePrams.qrcode_number"
                    placeholder="通过溯源码编码查询"
                ></Input>
                <Button
                    class="theme-bc mb24 mr24 theme-default-color"
                    icon="ios-search"
                    @click="goSearch"
                    >确认搜索</Button
                >
            </div>
        </div>

        <div class="content">
            <Table :columns="columnsTable" :data="dataTable" border>
                <template slot-scope="{ row }" slot="product_name">
                    <div>
                        <div>
                            商品:{{
                                row.product ? row.product.product_name : ""
                            }}
                        </div>
                        <div>
                            批次:{{ row.batch ? row.batch.batch_name : "" }}
                        </div>
                    </div>
                </template>
                <template slot-scope="{ row }" slot="agent_name">
                    <div>{{ row.agent ? row.agent.agent_name : "" }}</div>
                </template>
                <template slot-scope="{ row }" slot="operate">
                    <div class="flex-sa">
                        <Button type="primary" ghost @click="goRecover(row)"
                            >恢复</Button
                        >
                        <Button type="error" ghost @click="goDel(row)"
                            >删除</Button
                        >
                    </div>
                </template>
            </Table>
            <div class="page">
                <Page
                    :current="storePrams.page"
                    :page-size="storePrams.limit"
                    :total="total"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
import {
    trash_qrcode_list,
    trash_qrcode_forceDelete,
    trash_qrcode_restore,
} from "@/api/index";
export default {
    data() {
        return {
            storePrams: {
                page: 1,
                limit: 10,
                qrcode_number: "",
            },
            total: 0,
            columnsTable: [
                { title: "ID", key: "id", align: "center" },
                { title: "关联信息", slot: "product_name", align: "center" },
                { title: "代理商", slot: "agent_name", align: "center" },
                { title: "总数量", key: "qrcode_count", align: "center" },
                { title: "被删除数量", key: "deleted_num", align: "center" },
                { title: "删除时间", key: "created_at", align: "center" },
                {
                    title: "操作",
                    slot: "operate",
                    align: "center",
                    width: "200px",
                },
            ],
            dataTable: [],
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            trash_qrcode_list(this.storePrams)
                .then((res) => {
                    this.dataTable = res.data.data;
                    this.total = res.data.total;
                    // 删除后，page--
                    if (!res.data.data.length && this.storePrams.page != 1) {
                        this.storePrams.page--;
                        this.getList();
                    }
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
        goSearch() {
            this.storePrams.page = 1;
            this.getList();
        },

        goRecover(row) {
            this.$Modal.confirm({
                title: "提示",
                content: "是否确认恢复？",
                onOk: () => {
                    trash_qrcode_restore({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.info({ content: '正在恢复', duration: 5 });
                        })
                        .catch((err) => {
                            this.$Message.error(err.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        goDel(row) {
            this.$Modal.confirm({
                title: "提示",
                content: "一旦删除，无法恢复。是否确认删除？",
                onOk: () => {
                    trash_qrcode_forceDelete({ id: row.id })
                        .then((res) => {
                            this.getList();
                            this.$Message.info({ content: '正在删除', duration: 5 });
                        })
                        .catch((res) => {
                            this.$Message.error(res.msg);
                        })
                },
                onCancel: () => {},
            });
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.header-container {
    padding: 24px 24px 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.header {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
    height: 100%;
}
.page {
    margin-top: 24px;
    text-align: right;
    white-space: nowrap;
}
.width_height_100 {
    width: 100%;
    height: 100%;
}
.width_height_30 {
    width: 30px;
    height: 30px;
}
.qrcode-date {
    display: block;
}
::v-deep .ivu-checkbox-wrapper-checked.ivu-checkbox-border {
    background: #53c41a;
    border-radius: 5px;
    font-size: 14px;
    color: #fff;
    border-color: #53c41a;
}
::v-deep .ivu-checkbox {
    display: none;
}
::v-deep .ivu-checkbox.ivu-checkbox-checked {
    display: none;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53c41a;
    border-color: #53c41a;
    box-shadow: -1px 0 0 0 #53c41a;
    border-radius: 5px;
    color: #fff;
    z-index: 1;
}
::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
    border-color: #ff761d;
    background-color: #ff761d;
}
/* 表头背景颜色 */
::v-deep .ivu-table-header thead tr th {
    background: rgba(198, 44, 44, 0) !important;
    box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 0.99);
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
.width_height_18 {
    width: 18px;
    height: 18px;
}
.width_height_200 {
    width: 200px;
    height: 200px;
    border: 1px solid #9fa5bb;
}
.width_15 {
    width: 15vw;
}
.flex-column {
    flex-direction: column !important;
}
.product-title {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 15px;
    color: #484e66;
    margin-bottom: 10px;
}
.img-divs {
    background: #f1f5f8;
    border-radius: 4px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 12px 12px 0 12px;
}
.img-div {
    width: 70px;
    height: 70px;
    background: #ffffff;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: 0 12px 12px 0;
}
.img-div-icon {
    width: 25px;
}
.img-txt {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
}
.upload-div {
    position: relative;
    width: 70px;
    height: 70px;
    margin: 0 12px 12px 0;
}
.upload-del {
    position: absolute;
    top: -6px;
    right: -6px;
    cursor: pointer;
}
.upload-img {
    width: 70px;
    height: 70px;
    border-radius: 4px;
}
.cursor-p {
    cursor: pointer;
}
</style>